import { Button } from "@svea/design-system-components-react";
import { useState } from "react";
import { Dialog } from "../../../dialog";

type PreviewProps = {
	file?: File;
	fileFetcher?: () => Promise<Blob>;
};

export const Preview = ({ file, fileFetcher }: PreviewProps) => {
	const [previewOpen, setPreviewOpen] = useState(false);
	const [iUrl, setIUrl] = useState<string>();

	const handleOpenPreview = async () => {
		if (file) {
			setIUrl(URL.createObjectURL(file));
		} else if (fileFetcher) {
			const f = await fileFetcher();
			setIUrl(URL.createObjectURL(f));
		}
		setPreviewOpen(true);
	};

	return (
		<>
			<Button aria-label="icon" icon="visible" onPress={handleOpenPreview} variant="icon" />
			<Dialog isOpen={previewOpen} heading="" setOpen={setPreviewOpen} size="full">
				<object
					className="tablet:min-h-[70vh] min-h-[60vh] w-full"
					title="preview"
					type="application/pdf"
					data={iUrl}
				>
					Unsupported file type
				</object>
			</Dialog>
		</>
	);
};
